module.exports = __webpack_public_path__ + "static/media/CT_2019_30457A.23c6c72f.png";